import { useEffect, useState } from "react";

const TARGET = new Date("2026-10-31T15:00:00-03:00").getTime();

function diff() {
  const d = Math.max(0, TARGET - Date.now());
  return {
    Dias: Math.floor(d / 864e5),
    Horas: Math.floor(d / 36e5) % 24,
    Min: Math.floor(d / 6e4) % 60,
    Seg: Math.floor(d / 1e3) % 60,
  };
}

export default function Countdown() {
  const [t, setT] = useState(diff());

  useEffect(() => {
    const i = setInterval(() => setT(diff()), 1000);
    return () => clearInterval(i);
  }, []);

  return (
    <div className="flex gap-3 md:gap-5 justify-center flex-wrap" data-testid="countdown-timer">
      {Object.entries(t).map(([label, v]) => (
        <div key={label} className="lux-card px-4 py-3 md:px-6 md:py-4 text-center min-w-[72px]">
          <div className="font-display gold-text text-3xl md:text-4xl tabular-nums">{String(v).padStart(2, "0")}</div>
          <div className="text-[10px] tracking-[0.3em] uppercase mt-1" style={{ color: "var(--muted)" }}>
            {label}
          </div>
        </div>
      ))}
    </div>
  );
}
